<template>
  <div id="rename">
    <el-dialog
      :title="$t('Rename')"
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      @close="viewClose"
    >
      <div>
        <el-input :placeholder="$t('enter_name')" v-model="name" maxlength="30"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="viewClose()"  style="border-radius:16px">{{$t('Cancel')}}</el-button>
        <el-button size="mini" type="primary" @click="changeName()"  style="border-radius:16px">{{$t('OK')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 这里导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
  name: "rename",
  // 引入的组件需要注入到对象中
  components: {},
  // 定义props属性
  props: {
    visible: Boolean,
    rename: String
  },
  // 数据层
  data() {
    return {
      name: "",
      dialogVisible: false
    };
  },
  computed: {},
  watch: {
    visible: function (val) {
      this.dialogVisible = val;
    },
    dialogVisible: function (val) {
      if (val) {
        this.name = this.rename;
      }
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  deactivated() {
    this.viewClose();
  },
  // 方法
  methods: {
    viewClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
    changeName() {
      if(!this.name.trim()) {
        this.$message.error(this.$t('enter_name'));
        return;
      }
      this.dialogVisible = false;
      this.$emit("changeName", this.name)
    }
  }
};
</script>

<style scoped lang="scss">
/* @import url(); 引入公共css类 */
#rename {
  :deep(.el-dialog__header) {
    text-align: center;
    padding-top: 10px;
    .el-dialog__title {
      // height: 18px;
      
      // font-weight: normal;
      // font-size: 13px;
      // color: #3D3D3D;
      // line-height: 18px;
    }
    .el-dialog__headerbtn {
      top: 10px;
    }
  }
  :deep(.el-dialog__body) {
    padding: 20px;
  }
  :deep(.el-dialog__footer) {
    padding-top: 20px;
  }
  :deep(.el-dialog) {
    width: 500px;
    box-sizing: border-box;
  }
}
</style>
